import CadastroMensagem from './CadastroMensagem'

export default CadastroMensagem